import { useParams, Link } from 'react-router-dom'
import Breadcrumbs from '../components/Breadcrumbs'
import BackButton from '../components/BackButton'

export default function EditGPSPage() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-green-100 dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-8">
        <Breadcrumbs 
          items={[
            { label: 'Courses', href: '/courses' },
            { label: 'Course', href: `/courses/${id}` },
            { label: 'Edit GPS' }
          ]}
        />
        
        <BackButton to={`/courses/${id}`} label="Back to Course" className="mb-4" />
        
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">Edit GPS Coordinates</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-4">Edit GPS coordinates for course ID: {id}</p>
        
        <div className="flex gap-3 mt-8">
          <Link 
            to="/dashboard" 
            className="inline-block px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            Back to Dashboard
          </Link>
          <Link 
            to={`/courses/${id}`} 
            className="inline-block px-4 py-2 bg-golf-600 text-white rounded-lg hover:bg-golf-700 transition-colors"
          >
            View Course
          </Link>
        </div>
      </div>
    </div>
  )
}